import { serviceDeskContextResource } from '@atlassian/jira-router-resources-service-desk-context/src/services/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseServiceDeskContextResourceReturn } from './types.tsx';

export const useServiceDeskContextResource = (): UseServiceDeskContextResourceReturn => {
	const { data, loading } = useResource(serviceDeskContextResource);
	return { data, loading };
};
